import { useMemo } from 'react'
import { InspectorDataArtboard } from './inspectorDataType'

/**
 * Check if at least one layer in the artboard has exportable assets. This does not
 * count exportable assets at the artboard level.
 * This is use to decide if we want to show the "No exportable assets" message
 * or if we prefer to not show anything when the selected layer does not have any
 * exportable assets.
 * @see https://github.com/sketch-hq/Cloud/issues/6669#issuecomment-748183677
 *
 * Note: This hook is called from ArtboardDetailInspectorProvider and the value is stored
 * in the inspector context so you can read it directly from the `useInspectorContext` instead
 * of calling useHasAnyLayerWithExportableAssets somewhere else.
 */
export function useHasAnyLayerWithExportableAssets(
  inspectorData: InspectorDataArtboard | null
) {
  return useMemo(() => {
    if (!inspectorData) {
      return false
    }
    return checkHasAnyLayerWithExportableAssets(inspectorData)
  }, [inspectorData])
}

function checkHasAnyLayerWithExportableAssets(
  inspectorData: InspectorDataArtboard
): boolean {
  if (!inspectorData || !inspectorData.layers) {
    return false
  }

  return Object.values(inspectorData.layers).some(
    layer => layer.exportFormats?.length
  )
}
